// import { forEach } from 'core-js/core/array'
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
// import router from '../../src/router'

/* eslint-disable */

// ── Translation utility (MyMemory free API, no key needed) ──────────────────
const LANG_CODES = { he: 'he-IL', ar: 'ar-AR', en: 'en-US', fr: 'fr-FR', de: 'de-DE', ru: 'ru-RU', es: 'es-ES' };
async function translateText(text, fromLang, toLang) {
  if (!text || !text.trim() || fromLang === toLang) return text;
  try {
    const from = LANG_CODES[fromLang] || fromLang;
    const to   = LANG_CODES[toLang]   || toLang;
    const url  = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=${from}|${to}`;
    const res  = await fetch(url);
    const data = await res.json();
    return (data.responseStatus === 200 && data.responseData?.translatedText) ? data.responseData.translatedText : text;
  } catch (e) {
    console.warn(`[translate] ${fromLang}→${toLang} failed:`, e);
    return text;
  }
}

// Translate translatable fields of a point for a target language
async function translatePoint(pointData, fromLang, toLang) {
  const clone = { ...pointData };
  if (clone.pointInformation) clone.pointInformation = await translateText(clone.pointInformation, fromLang, toLang);
  if (clone.missingWord)      clone.missingWord      = await translateText(clone.missingWord,      fromLang, toLang);
  return clone;
}

// Translate translatable fields of a question for a target language
async function translateQuestion(qData, fromLang, toLang) {
  const clone = { ...qData };
  const fields = ['question', 'correctAnswer', 'wrongAnswer1', 'wrongAnswer2', 'wrongAnswer3'];
  await Promise.all(fields.map(async f => {
    if (clone[f]) clone[f] = await translateText(clone[f], fromLang, toLang);
  }));
  return clone;
}

// Fetch available languages for a navigation game
async function getGameLangs(navigationName) {
  const snap = await firebase.database().ref(navigationName + '/languages').once('value');
  return snap.val() || ['he'];
}

// Fields that are shared across languages (stored once in pointImages/)
const IMAGE_FIELDS = ['imageBase64', 'imageUrl', 'puzzleImageBase64', 'itemImage1', 'itemImage2', 'itemImage3', 'itemImage4', 'signCardImageBase64'];

// Resize a File/Blob to max width and return a Blob (for Storage upload)
function fileToResizedBlob(file, maxWidth = 500) {
  return new Promise(resolve => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = img.width > maxWidth ? maxWidth / img.width : 1;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      canvas.toBlob(blob => resolve(blob || file), 'image/jpeg', 0.85);
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
    img.src = url;
  });
}

// Resize a File/Blob to max 450px wide and return a base64 string
function fileToResizedBase64(file, maxWidth = 450) {
  return new Promise(resolve => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      const scale = img.width > maxWidth ? maxWidth / img.width : 1;
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.onerror = () => { URL.revokeObjectURL(url); resolve(''); };
    img.src = url;
  });
}

// Split a point payload into { imageData, pointData } — images go to shared path
function splitImageFields(data) {
  const imageData = {};
  const pointData = { ...data };
  IMAGE_FIELDS.forEach(f => {
    if (data[f] !== undefined) { imageData[f] = data[f]; delete pointData[f]; }
  });
  return { imageData, pointData };
}

// Merge shared images from pointImages object into a points array
function mergeSharedImages(points, pointImages) {
  if (!pointImages) return points;
  return points.map(p => ({
    ...p,
    ...(pointImages[String(p.pointNumber)] || {}),
  }));
}
export default {
  state: {
    questions: [],
    points: [],
    markers: [],
    mapParameters: "",
    imageUrl: "",
    gameData: "",
    sentence: "",
    welcomePageData: "",
    loading: false,
    results: [],
    questionsList: "",
    lang: "he",
    wazeLink: '',
    wayPoints: [],
    users: [],
    arrayOfAudioUrl: [],
    arrayOfPointInfo: [],
    arrayOfImagesBase64: [],
    questionsOrder: "",
    questionsArray: [],
    storyItems: [],
  },
  mutations: {
    setWazeLink(state, payload) {
      state.wazeLink = payload;
    },
    switchLang(state, payload) {
      console.log("[switchLang] payload", payload);
      state.lang = payload;
    },
    setQuestionList(state, payload) {
      // console.log("[setQuestionList] payload", payload)
      state.questionsList = payload;
    },
    addResult(state, payload) {
      state.results.push(payload);
    },
    setMapParameters(state, payload) {
      state.mapParameters = payload;
    },
    setWelcomePage(state, payload) {
      // console.log('[mutations] setWelcomePage payload', payload)
      state.welcomePage = payload;
    },
    setLettersArray(state, payload) {
      state.lettersArray = payload;
    },
    setWayPoints(state, payload) {
      state.wayPoints = payload;
    },
    setGameParameters(state, payload) {
      state.gameParameters = payload;
    },
    setAllNavGameNames(state, payload) {
      state.allNavGameNames = payload;
    },
    setUser(state, payload) {
      // console.log("[setUser] payload", payload)
      state.user = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
      console.log("[mutations] setLoading => state.loading", state.loading);
    },
    setPointsArray(state, payload) {
      state.pointsArrayOrder = payload;
    },
    setStoryItems(state, payload) {
      state.storyItems = payload;
    },
    setPoints(state, payload) {
      state.points = payload;
    },
    setArrayOfAudioUrl(state, payload) {
      state.arrayOfAudioUrl = payload;
    },
    setArrayOfPointInfo(state, payload) {
      state.arrayOfPointInfo = payload;
    },

    setArrayOfImagesBase64(state, payload) {
      state.arrayOfImagesBase64 = payload;
    },
    setMarkers(state, payload) {
      state.markers = payload;
    },
    setQuestions(state, payload) {
      state.questions = payload;
    },
    setQuestionsSuffled(state, payload) {
      state.questionsShuffled = payload;
    },
    setQuestionsArray(state, payload) {
      state.questionsArray = payload;
    },
    addPoint(state, payload) {
      console.log("addpoint", payload);
      state.points.push(payload);
    },
    addMarker(state, payload) {
      state.markers.push(payload);
    },
    // addUser(state, payload) {
    //     console.log("[addUser] payload", payload)
    //     state.users.push(payload)
    // },
    addUserListArray(state, payload) {
      state.users = payload;
    },

    setResults(state, payload) {
      state.results = payload;
    },
  },
  actions: {
    sendComment({}, payload) {
      const db = firebase.database();
      db.ref(payload.navigationName + "/comments/").push(payload);
    },
    sendEmail({}, payload) {
      const db = firebase.database();
      db.ref(payload.navigationName + "/emails/").push(payload.email);
    },
    addEvolutionToDB({}, payload) {
      const db = firebase.database();
      let pointNumber = payload.pointNumber;
      // console.log("addEvolutionToDB payload", payload)
      /////////////////////////    HERE I CHANGED TO SET({pointNumber: payload.pointNumber}) to (pointNumber)
      db.ref(
        payload.navigationName + "/users/" + payload.userKey + "/evolution/",
      ).set(pointNumber);
    },
    getResultsByPoints({ dispatch, commit }, payload) {
      const db = firebase.database();
      db.ref(payload + "/results")
        .orderByChild("errorNumber")
        .on("value", (resultsInfoOrderByChild) => {
          let arrayOfResults = [];
          resultsInfoOrderByChild.forEach(function (results) {
            arrayOfResults.push(results.val());
          });
          arrayOfResults.reverse();
          const ranked = arrayOfResults.map((result, i) => ({
            resultsOfTheGame: result,
            place: i + 1,
          }));
          commit("setResults", ranked);
        });
    },
    checkResults({ getters, dispatch }, payload) {
      console.log("[check results] payload,", payload);

      let userName = getters.user?.userName || localStorage.getItem("myNameOuchui") || "Guest";
      let navigationName = getters.gameParameters.navigationName;
      const db = firebase.database();
      var pad = function (num, size) {
          return ("000" + num).slice(size * -1);
        },
        time = parseFloat(
          payload.gameTimeInSecond + payload.errorNumber * 60,
        ).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60);

      var totalTime =
        pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
      // db.ref('groups/results/' + userName).set(errors)
      var totalSeconds = payload.gameTimeInSecond + payload.errorNumber * 60;
      console.log(
        "[checkAnswer index.js] B4 checkResults - userName - navigationName",
        userName,
        navigationName,
      );

      db.ref(
        navigationName + "/results/" + localStorage.getItem("userKey"),
      ).update({
        errorNumber: payload.errorNumber,
        secondsToTime: payload.gameSecondToTime,
        totalSeconds: totalSeconds,
        totalTime: totalTime,
        userName: userName,
        NavigationEndTime: new Date().toString(),
      });
    },
    getResults({ dispatch, commit }, payload) {
      const db = firebase.database();
      db.ref(payload + "/results")
        .orderByChild("totalSeconds")
        .on("value", (resultsInfoOrderByChild) => {
          let index = 0;
          resultsInfoOrderByChild.forEach(function (results) {
            index++;
            var resultsOfTheGame = results.val();
            // console.log("resultsOfTheGame ", resultsOfTheGame)
            commit("addResult", {
              resultsOfTheGame: resultsOfTheGame,
              place: index,
            });
          });
        });
    },
    storePointsOrder({}, payload) {
      const db = firebase.database();
      db.ref(payload.navigationName + "/pointsOrder/").push(payload.pointsOrder);
    },
    updatePointsOrder({}, payload) {
      firebase.database()
        .ref(payload.navigationName + "/pointsOrder/" + payload.key)
        .set(payload.order);
    },
    deletePointsOrder({}, payload) {
      return firebase.database()
        .ref(payload.navigationName + "/pointsOrder/" + payload.key)
        .remove();
    },
    async deletePoint({}, payload) {
      // payload: { navigationName, pointNumber }
      const db = firebase.database();
      const { navigationName, pointNumber } = payload;

      // 1. Get all language branches
      const langsSnap = await db.ref(navigationName + '/languages').once('value');
      const langs = langsSnap.val() || ['he'];

      // 2. Delete point data from all language branches
      await Promise.all(langs.map(lang =>
        db.ref(navigationName + '/' + lang + '/points/' + pointNumber).remove()
      ));

      // 3. Delete shared images
      await db.ref(navigationName + '/pointImages/' + pointNumber).remove();

      // 4. Delete marker
      await db.ref(navigationName + '/markers/' + pointNumber).remove();

      // 5. Delete Storage image (best-effort)
      try {
        await firebase.storage().ref(navigationName + '/points/' + pointNumber + '.png').delete();
      } catch (_) {}
    },
    storeMapParameters({}, payload) {
      const db = firebase.database();
      // console.log("storeMapParameters => payload", payload)
      // if (payload.lat != '') {
      db.ref(payload.navigationName + "/mapParameters/lat").set(payload.lat);
      // }
      // if (payload.lng != '') {
      db.ref(payload.navigationName + "/mapParameters//lng").set(payload.lng);
      // }
      // if (payload.zoom != '') {
      db.ref(payload.navigationName + "/mapParameters//zoom").set(payload.zoom);
      // }
    },
    saveDisplayName({}, payload) {
      firebase.database().ref(payload.navigationName + '/displayName').set(payload.displayName);
    },

    saveStartLocationName({}, { navigationName, startLocationName }) {
      firebase.database().ref(navigationName + '/startLocationName').set(startLocationName);
    },
    saveGameModeHistoire({}, { navigationName, gameMode }) {
      return firebase.database().ref(navigationName + '/gameMode').set(gameMode);
    },
    saveStoryItems({ commit }, { navigationName, storyItems }) {
      const clean = storyItems.map(item => {
        const { _open, _addingQuestion, _nq, ...rest } = item;
        return rest;
      });
      commit('setStoryItems', clean);
      return firebase.database().ref(navigationName + '/storyItems').set(clean);
    },

    async saveGameMode({}, { navigationName, questionsOrder, randomQuestions }) {
      const db = firebase.database();
      await db.ref(navigationName + '/questionsOrder').set(questionsOrder);
      await db.ref(navigationName + '/randomQuestions').set(!!randomQuestions);
    },

    async saveBgImage({}, { navigationName, file }) {
      const storageRef = firebase.storage().ref(navigationName + '/bgImage.jpg');
      const resizedBlob = await fileToResizedBlob(file, 500);
      await storageRef.put(resizedBlob);
      const url = await storageRef.getDownloadURL();
      await firebase.database().ref(navigationName + '/bgImage').set(url);
      return url;
    },

    storeEndPoint({}, payload) {
      const db = firebase.database();
      // console.log("storeEndPoint => payload", payload)
      db.ref(payload.navigationName + "/lastPoint").set(payload.endPoint);
    },
    createNewGame({ commit, getters }, payload) {
      const db = firebase.database();
      const { uid, ...gameData } = payload;
      const data = uid ? { ...gameData, owner: uid } : gameData;
      db.ref(gameData.navigationName).set(data);
      db.ref('gameNames/' + gameData.navigationName).set(true);
      if (uid) {
        db.ref('userGames/' + uid + '/' + gameData.navigationName).set(true);
      }
    },

    fetchUserGames({}, uid) {
      if (!uid) return Promise.resolve([]);
      return firebase.database().ref('userGames/' + uid).once('value')
        .then(snap => {
          const data = snap.val();
          return data ? Object.keys(data) : [];
        });
    },

    checkGameNameAvailable({}, gameName) {
      return firebase.database().ref(gameName).once('value')
        .then(snap => !snap.exists());
    },
    async createNewPoint({ commit }, payload) {
      commit("setLoading", true);
      console.log("[createNewPoint]");
      const db = firebase.database();
      const langsSnap = await db.ref(payload.navigationName + '/languages').once('value');
      const langs = langsSnap.val() || ['he'];

      const uiOnlyFields = ['_file', '_puzzleFile', 'imagePreview', 'puzzleImagePreview', '_open', 'editMode', '_original', '_questions', '_addingQuestion', '_nq', '_arCompiling', '_arProgress'];
      const defaultFields = {
        audioUrl: '', description1: '', description2: '', description3: '', description4: '',
        missingWord: '', navigationScreen: 'imagesList', navigationName: '',
        noGoogleRoute: false, photoInstruction: '', picked: 'questions',
        pictures: {}, pointInformation: '',
        timePerPoint: 2, videoUrl: '', withVideo: false,
        withPhone: false, callerName: '', phoneAudioUrl: '',
        justeFauxQuestion: '', justeFauxItems: [],
        motManquantText: '', motManquantMode: 'visible',
        arGrowAnimation: true,
        rushHourVehicles: [],
        signCardImageBase64: '', signCardImageUrl: '',
        signCardSigHeightPct: 20, signCardSigVAlign: 'bottom', signCardSigHAlign: 'center',
      };
      const filteredData = Object.fromEntries(
        Object.entries(payload).filter(([key]) => !uiOnlyFields.includes(key))
      );
      const allData = { ...defaultFields, ...filteredData };

      // Split: images go to shared path, text/config to language branches
      const { imageData, pointData } = splitImageFields(allData);

      // Handle Storage upload — imageUrl goes into shared images too
      if (payload.image) {
        try {
          const storageRef = firebase.storage().ref(payload.navigationName + "/points/" + payload.pointNumber + ".png");
          const resizedBlob = await fileToResizedBlob(payload.image);
          await storageRef.put(resizedBlob);
          imageData.imageUrl = await storageRef.getDownloadURL();
          imageData.imageBase64 = await fileToResizedBase64(payload.image);
        } catch(e) { console.warn('Storage upload failed', e); }
      }

      // Write images once to shared path
      if (Object.keys(imageData).length > 0) {
        await db.ref(payload.navigationName + "/pointImages/" + payload.pointNumber).update(imageData);
      }

      // Write text/config to all language branches (with translation)
      const sourceLang = payload.lang || 'he';
      await Promise.all(langs.map(async lang => {
        const data = lang === sourceLang ? pointData : await translatePoint(pointData, sourceLang, lang);
        return db.ref(payload.navigationName + "/" + lang + "/points/" + payload.pointNumber).set(data);
      }));

      commit("addPoint", { ...pointData, ...imageData });
      commit("setLoading", false);
    },
    async createNewQuestion({ commit }, payload) {
      commit("setLoading", true);
      const db = firebase.database();
      const langs = await getGameLangs(payload.navigationName);
      const sourceLang = payload.lang || 'he';
      await Promise.all(langs.map(async lang => {
        const qData = lang === sourceLang ? payload.question : await translateQuestion(payload.question, sourceLang, lang);
        return db.ref(payload.navigationName + "/" + lang + "/questions").push(qData);
      }));
      commit("setLoading", false);
    },
    async updatQuestion({ commit }, payload) {
      commit("setLoading", true);
      const db = firebase.database();
      const langs = await getGameLangs(payload.navigationName);
      const sourceLang = payload.lang || 'he';
      await Promise.all(langs.map(async lang => {
        const qData = lang === sourceLang ? payload.question : await translateQuestion(payload.question, sourceLang, lang);
        return db.ref(payload.navigationName + "/" + lang + "/questions/" + payload.key).update(qData);
      }));
      commit("setLoading", false);
    },
    async updatePoint({ getters }, payload) {
      const db = firebase.database();

      const uiOnlyFields = ['_file', '_puzzleFile', 'imagePreview', 'puzzleImagePreview', '_open', 'editMode', '_original', '_arCompiling', '_arProgress', '_showPhone', '_showText', '_showAudio'];
      const defaultFields = {
        audioUrl: '', description1: '', description2: '', description3: '', description4: '',
        missingWord: '', navigationScreen: 'imagesList', navigationName: '',
        noGoogleRoute: false, photoInstruction: '', picked: 'questions',
        pictures: {}, pointInformation: '',
        timePerPoint: 2, videoUrl: '', withVideo: false,
        withPhone: false, callerName: '', phoneAudioUrl: '',
        justeFauxQuestion: '', justeFauxItems: [],
        motManquantText: '', motManquantMode: 'visible',
        arGrowAnimation: true,
        rushHourVehicles: [],
        signCardImageBase64: '', signCardImageUrl: '',
        signCardSigHeightPct: 20, signCardSigVAlign: 'bottom', signCardSigHAlign: 'center',
      };
      const filteredData = Object.fromEntries(
        Object.entries(payload).filter(([key]) => !uiOnlyFields.includes(key))
      );
      const allData = { ...defaultFields, ...filteredData };

      // Split images from text/config
      const { imageData, pointData } = splitImageFields(allData);

      // Storage upload if new file picked
      if (payload._file) {
        try {
          const storageRef = firebase.storage().ref(payload.navigationName + '/points/' + payload.pointNumber + '.png');
          const resizedBlob = await fileToResizedBlob(payload._file);
          await storageRef.put(resizedBlob);
          imageData.imageUrl = await storageRef.getDownloadURL();
          imageData.imageBase64 = await fileToResizedBase64(payload._file);
        } catch (e) { console.warn('Storage upload failed, saving base64 only', e); }
      } else {
        // No new file — don't overwrite imageBase64/imageUrl in Firebase.
        // Keeping stale base64 would persist old images; leave those fields untouched.
        delete imageData.imageBase64;
        delete imageData.imageUrl;
      }

      // Write images once to shared path
      if (Object.keys(imageData).length > 0) {
        await db.ref(payload.navigationName + "/pointImages/" + payload.pointNumber).update(imageData);
      }

      // Write text/config to all language branches (with translation)
      const langs = await getGameLangs(payload.navigationName);
      const sourceLang = payload.lang || getters.lang || 'he';
      await Promise.all(langs.map(async lang => {
        const data = lang === sourceLang ? pointData : await translatePoint(pointData, sourceLang, lang);
        return db.ref(payload.navigationName + "/" + lang + "/points/" + payload.pointNumber).update(data);
      }));

      return { imageUrl: imageData.imageUrl || null };
    },
    async renumberPoint({}, { navigationName, oldNumber, newNumber }) {
      const db = firebase.database();
      const langs = await getGameLangs(navigationName);

      // 1. Copy + delete point data in every language branch
      await Promise.all(langs.map(async lang => {
        const snap = await db.ref(navigationName + '/' + lang + '/points/' + oldNumber).once('value');
        if (snap.exists()) {
          await db.ref(navigationName + '/' + lang + '/points/' + newNumber).set(snap.val());
          await db.ref(navigationName + '/' + lang + '/points/' + oldNumber).remove();
        }
      }));

      // 2. Copy + delete pointImages
      const imgSnap = await db.ref(navigationName + '/pointImages/' + oldNumber).once('value');
      if (imgSnap.exists()) {
        await db.ref(navigationName + '/pointImages/' + newNumber).set(imgSnap.val());
        await db.ref(navigationName + '/pointImages/' + oldNumber).remove();
      }

      // 3. Copy + delete marker
      const markerSnap = await db.ref(navigationName + '/markers/' + oldNumber).once('value');
      if (markerSnap.exists()) {
        await db.ref(navigationName + '/markers/' + newNumber).set(markerSnap.val());
        await db.ref(navigationName + '/markers/' + oldNumber).remove();
      }

      // 4. Update pointLinked in all questions for all languages
      await Promise.all(langs.map(async lang => {
        const qSnap = await db.ref(navigationName + '/' + lang + '/questions').once('value');
        if (!qSnap.exists()) return;
        const updates = {};
        qSnap.forEach(child => {
          if (String(child.val().pointLinked) === String(oldNumber)) {
            updates[child.key + '/pointLinked'] = newNumber;
          }
        });
        if (Object.keys(updates).length > 0) {
          await db.ref(navigationName + '/' + lang + '/questions').update(updates);
        }
      }));
    },

    createNewMarker({ commit }, payload) {
      const db = firebase.database();
      // console.log("[createNewMarker] payload", payload)
      // commit('addMarker', payload.position)
      db.ref(payload.navigationName + "/markers/" + payload.pointNumber).set(
        payload.position,
      );
    },
    createNewUser({ commit }, payload) {
      const db = firebase.database();
      let pointNumber;
      var navigationHour = new Date().toString();
      //IF THE USER ALREADY EXIST THEN THIS********
      if (localStorage.getItem("userKey")) {
        if (payload.pointNumber) {
          pointNumber = payload.pointNumber;
        } else {
          pointNumber = 0;
        }
        console.log("FOR Evolution payload.pointNumber", payload.pointNumber);
        db.ref(
          payload.navigationName + "/users/" + localStorage.getItem("userKey"),
        ).update({
          userName: payload.userName,
          //NavigationTime: navigationHour,
          // groupColorEnglish: payload.groupColorEnglish,
          evolution: parseInt(pointNumber),
        });
        commit("setUser", payload);
      } else {
        //OTHERWISE THE USER DOES NOT EXIT THEN THIS:************
        db.ref(payload.navigationName + "/users")
          .push({
            userName: payload.userName,
            NavigationTime: navigationHour,
            // groupColorEnglish: payload.groupColorEnglish,
          })
          .then((user) => {
            localStorage.setItem("userKey", user.key);
          });
        commit("setUser", payload);
      }
    },

    //   ******************************* FETCH PART ******************************************
    fetchAllNavGames({ commit }) {
      commit("setLoading", true);
      const db = firebase.database();
      const user = firebase.auth().currentUser;
      const tokenPromise = user ? user.getIdToken() : Promise.resolve(null);
      return tokenPromise
        .then((token) => {
          const url = token
            ? `https://eifoany.firebaseio.com/.json?shallow=true&auth=${token}`
            : `https://eifoany.firebaseio.com/.json?shallow=true`;
          return fetch(url);
        })
        .then((r) => {
          if (!r.ok) throw new Error("HTTP " + r.status);
          return r.json();
        })
        .then((data) => {
          const names = Object.keys(data).filter((k) => k !== "gameNames");
          commit("setAllNavGameNames", names);
          commit("setLoading", false);
        })
        .catch(() => {
          // Fallback SDK si l'API REST est inaccessible
          return db.ref("gameNames").once("value").then((snap) => {
            const data = snap.val();
            commit("setAllNavGameNames", data ? Object.keys(data) : []);
            commit("setLoading", false);
          });
        });
    },
    // ONLY IN USE FOR ADMIN - MAYBE SHOULD BE FETCHGAMEDATA INSTEAD IN ADMIN
    fetchNavtigationData({ commit, dispatch, getters }, payload) {
      commit("setLoading", true);

      firebase
        .database()
        .ref(payload)
        .once("value")
        .then((data) => {
          let navigationData = data.val();
          var gameParameters = {
            // anniversary: navigationData.anniversary,
            infoPage: navigationData.infoPage,
            navigationName: navigationData.navigationName,
            displayName: navigationData.displayName || '',
            bgImage: navigationData.bgImage || '',
            randomQuestions: navigationData.randomQuestions,
            lastPoint: navigationData.lastPoint,
            pointsArrayOrder: navigationData.pointsOrder,
            carousel: navigationData.carousel,
            withVideo: navigationData.withVideo,
            imagesList: navigationData.imagesList,
            languages: navigationData.languages || ['he'],
            startLocationName: navigationData.startLocationName || '',
            questionsOrder: navigationData.questionsOrder || 'linkedToPointNumber',
          };
          commit("setGameParameters", gameParameters);
          console.log("[fetchNavtigationData] navigationData", navigationData);
          console.log("[fetchNavtigationData] gameParameters", gameParameters);

          this.mapParameters = navigationData.mapParameters;
          console.log(
            "[fetchNavtigationData] this.mapParameters",
            this.mapParameters,
          );
          commit("setMapParameters", this.mapParameters);
          this.endPoint = navigationData.endPoint;
          commit("setLoading", false);
        });
      firebase
        .database()
        .ref(payload + "/he/questions")
        .once("value")
        .then((data) => {
          let questions = [];
          data.forEach((question) => {
            // console.log("getters.lang", getters.lang)
            // console.log("question.val()", question.val())
            questions.push({
              key: question.key,
              data: question.val(),
            });
            // questions.push()
          });
          commit("setQuestionList", questions);
        });
    },
    fetchConfirmationPhrase({ commit }, payload) {
      commit("setLoading", true);
      firebase
        .database()
        .ref(payload.navigationName)
        .once("value")
        .then((data) => {
          this.welcomePageData = data.val();
          // **************************FETCH GAME PARAMETERS
          var gameParameters = {
            welcomePhrase: this.welcomePageData.welcomePhrase,
            buttonStartGame: this.welcomePageData.buttonStartGame,
            welcomePhraseOne: this.welcomePageData.welcomePhraseOne,
            welcomePhraseTwo: this.welcomePageData.welcomePhraseTwo,
            welcomePhraseThree: this.welcomePageData.welcomePhraseThree,
            welcomePhraseFour: this.welcomePageData.welcomePhraseFour,
            welcomePhraseFive: this.welcomePageData.welcomePhraseFive,
          };
          commit("setWelcomePage", gameParameters);
        });
      commit("setLoading", false);
    },
    // fetchPoints({ commit, getters }, payload) {
    //   // commit('setLoading', true)
    //   firebase
    //     .database()
    //     .ref(payload)
    //     .once("value")
    //     .then((data) => {
    //       // if (getters.lang == "fr") {
    //       //*********************************************************************************************************** */
    //       // this.points = data.val().he.points;
    //       if (getters.lang == "he") {
    //         this.points = data.val().he.points;
    //       } else {
    //         this.points = data.val().ar.points;
    //       }
    //       //*********************************************************************************************************** */

    //       // } else {
    //       //     this.points = data.val().en.points
    //       // }
    //       // console.log("[fetchPoints] this.points", this.points)
    //       commit("setPoints", this.points);
    //       //******************** FETCH MARKERS - USED TO GET THE GPS COORDONATE IN THE ADMIN PAGE
    //       this.markers = data.val().markers;
    //       // console.log("[fetchPoints] this.markers", this.markers)
    //       commit("setMarkers", this.markers);
    //     });
    //   // commit('setLoading', false)
    // },
    fetchPoints({ commit, getters }, payload) {
      if (!payload) return Promise.resolve();
      const db = firebase.database();
      const navigationName = typeof payload === 'string' ? payload : payload.name;
      const lang = (typeof payload === 'object' && payload.lang) ? payload.lang : (getters.lang || "he");

      const pointsPromise = db.ref(navigationName + "/" + lang + "/points").once("value");
      const imagesPromise = db.ref(navigationName + "/pointImages").once("value");
      const markersPromise = db.ref(navigationName + "/markers").once("value");

      return Promise.all([pointsPromise, imagesPromise, markersPromise])
        .then(([pointsSnap, imagesSnap, markersSnap]) => {
          const val = pointsSnap.val();
          if (!val) { commit("setPoints", []); return; }
          const arr = Array.isArray(val) ? val : Object.values(val);
          const rawPoints = arr.filter((p) => p !== null);
          // Merge shared images into each point
          const sharedImages = imagesSnap.val() || {};
          const cleanPoints = mergeSharedImages(rawPoints, sharedImages);
          commit("setPoints", cleanPoints);
          localStorage.setItem("allPointsData", JSON.stringify(cleanPoints));
          const markers = markersSnap.val();
          if (markers) commit("setMarkers", markers);
        })
        .catch((err) => console.error("Erreur fetchPoints:", err));
    },
    fetchQuestionsOnly({ commit, getters }, payload) {
      if (!payload) return Promise.resolve();
      const db = firebase.database();
      const navigationName = typeof payload === 'string' ? payload : payload.name;
      const lang = (typeof payload === 'object' && payload.lang) ? payload.lang : (getters.lang || "he");
      return db
        .ref(navigationName + "/" + lang + "/questions")
        .once("value")
        .then((snap) => {
          const questions = [];
          snap.forEach((q) => { questions.push({ key: q.key, data: q.val() }); });
          commit("setQuestionList", questions);
        })
        .catch((err) => console.error("Erreur fetchQuestionsOnly:", err));
    },
    fetchUsersList({ commit }, payload) {
      const db = firebase.database();
      db.ref(payload + "/users")
        .orderByChild("evolution")
        .on("value", function (users) {
          var userListArray = [];
          users.forEach(function (child) {
            if (child.val().evolution != undefined) {
              userListArray.push({
                evolution: child.val().evolution,
                userName: child.val().userName,
              });
            }
          });
          let sortedUsersList = userListArray.sort((a, b) => {
            const evolutionA = a.evolution;
            const evolutionB = b.evolution;
            let comparison = 0;
            if (evolutionA > evolutionB) {
              comparison = 1;
            } else if (evolutionA < evolutionB) {
              comparison = -1;
            }
            return comparison * -1;
          });
          commit("addUserListArray", sortedUsersList);
        });
    },
    fetchGameData({ commit, dispatch, getters }, payload) {
      commit("setLoading", true);

      // Always clear data that fetchGameData will rebuild fresh from Firebase.
      // Also clear everything if switching to a different game.
      const prevNav = localStorage.getItem("navigationName");
      const switchingGame = prevNav !== payload.navigationName;
      const alwaysClear = ["allPointsData", "arrayOfImagesBase64", "arrayOfAudioUrl", "arrayOfPointInfo", "gameParameters"];
      const switchClear  = ["pointsArrayOrder", "questionsArray", "questionsShuffled", "markers", "wayPoints", "errorNumber"];
      alwaysClear.forEach(k => localStorage.removeItem(k));
      if (switchingGame) switchClear.forEach(k => localStorage.removeItem(k));

      localStorage.setItem("navigationName", payload.navigationName);

      return firebase
        .database()
        .ref(payload.navigationName)
        .once("value")
        .then((data) => {
          const fullData = data.val();
          if (!fullData) return;

          this.gameData = fullData;

          // 1. PARAMÈTRES DU JEU
          const gameParameters = {
            infoPage: this.gameData.infoPage,
            navigationName: this.gameData.navigationName,
            displayName: this.gameData.displayName || '',
            bgImage: this.gameData.bgImage || '',
            randomQuestions: this.gameData.randomQuestions,
            lastPoint: this.gameData.lastPoint,
            carousel: this.gameData.carousel,
            withVideo: this.gameData.withVideo,
            questionsOrder: this.gameData.questionsOrder,
            imagesList: this.gameData.imagesList,
            startLocationName: this.gameData.startLocationName || '',
            gameMode: this.gameData.gameMode || 'geographique',
          };
          commit("setGameParameters", gameParameters);
          localStorage.setItem(
            "gameParameters",
            JSON.stringify(gameParameters),
          );

          // 1b. STORY ITEMS (mode histoire)
          const rawStoryItems = this.gameData.storyItems
            ? (Array.isArray(this.gameData.storyItems)
                ? this.gameData.storyItems
                : Object.values(this.gameData.storyItems))
            : [];
          commit("setStoryItems", rawStoryItems);

          // 2. RÉCUPÉRATION DES POINTS (Selon la langue)
          const langData = this.gameData[getters.lang] || this.gameData.he;
          const rawPoints = langData && langData.points ? langData.points : [];
          const rawArr = Array.isArray(rawPoints)
            ? rawPoints.filter((p) => p !== null)
            : Object.values(rawPoints).filter((p) => p !== null);
          // Merge shared images (stored once in pointImages/) into each point
          const points = mergeSharedImages(rawArr, this.gameData.pointImages || {});
          commit("setPoints", points);
          // Sauvegarde des points SANS les base64 pour éviter de saturer localStorage
          const pointsLean = points.map(p => {
            const { imageBase64, puzzleImageBase64, ...rest } = p;
            return rest;
          });
          try { localStorage.setItem("allPointsData", JSON.stringify(pointsLean)); } catch(e) { console.warn("allPointsData too large", e); }

          // 3. PRÉPARATION DES ARRAYS UTILES (Audio, Info, Images)
          const arrayOfAudioUrl = [];
          const arrayOfPointInfo = [];

          // Budget images : max 4 MB pour ne pas dépasser la limite localStorage (~5 MB)
          const IMAGE_BUDGET_BYTES = 4 * 1024 * 1024;
          let imageBytesUsed = 0;
          const arrayOfImagesBase64 = [];

          points.forEach((point) => {
            if (point) {
              arrayOfAudioUrl.push(point.audioUrl || "");
              arrayOfPointInfo.push(point.pointInformation || "");

              const b64 = point.imageBase64 || "";
              if (b64 && b64.startsWith("data:") && (imageBytesUsed + b64.length) <= IMAGE_BUDGET_BYTES) {
                imageBytesUsed += b64.length;
                arrayOfImagesBase64.push(b64);
              } else {
                arrayOfImagesBase64.push(point.imageUrl || "");
              }
            }
          });


          if (imageBytesUsed >= IMAGE_BUDGET_BYTES) {
            console.warn(`[images cache] Budget localStorage atteint (${Math.round(imageBytesUsed/1024)}KB). Certaines images ne sont disponibles qu'en ligne.`);
          }

          commit("setArrayOfAudioUrl", arrayOfAudioUrl);
          try { localStorage.setItem("arrayOfAudioUrl", JSON.stringify(arrayOfAudioUrl)); } catch(e) { console.warn("arrayOfAudioUrl too large", e); }

          commit("setArrayOfPointInfo", arrayOfPointInfo);
          try { localStorage.setItem("arrayOfPointInfo", JSON.stringify(arrayOfPointInfo)); } catch(e) { console.warn("arrayOfPointInfo too large", e); }

          commit("setArrayOfImagesBase64", arrayOfImagesBase64);
          try {
            localStorage.setItem("arrayOfImagesBase64", JSON.stringify(arrayOfImagesBase64));
          } catch(e) {
            console.warn("arrayOfImagesBase64 too large for localStorage — images only available online", e);
            // Dernier recours : sauver uniquement les URLs (pas de cache offline)
            const urlsOnly = arrayOfImagesBase64.map(v => (v && v.startsWith("data:") ? "" : v));
            try { localStorage.setItem("arrayOfImagesBase64", JSON.stringify(urlsOnly)); } catch(e2) { /* impossible */ }
          }

          // 4. PARAMÈTRES DE LA CARTE ET MARKERS
          if (this.gameData.mapParameters) {
            commit("setMapParameters", this.gameData.mapParameters);
            localStorage.setItem(
              "mapParameters",
              JSON.stringify(this.gameData.mapParameters),
            );
          }

          const markers = this.gameData.markers || [];
          commit("setMarkers", markers);
          localStorage.setItem("markers", JSON.stringify(markers));

          // 5. WAYPOINTS (Itinéraires)
          if (this.gameData.wayPoints) {
            const wayPoints = this.gameData.wayPoints.filter(
              (wp) => wp !== null,
            );
            commit("setWayPoints", wayPoints);
            localStorage.setItem("wayPoints", JSON.stringify(wayPoints));
          }

          // 6. ORDRE DES POINTS (RANDOM OU CACHE)
          const arraysOfPointsOrder = this.gameData.pointsOrder
            ? Object.values(this.gameData.pointsOrder)
            : [[1]];
          let randomPointsOrder;

          // Priorité : 1) localStorage (reprise en cours), 2) tirage aléatoire + sauvegarde
          if (localStorage.getItem("pointsArrayOrder")) {
            randomPointsOrder = JSON.parse(localStorage.getItem("pointsArrayOrder"));
          }

          if (!randomPointsOrder || randomPointsOrder.length === 0) {
            // Tirage aléatoire parmi les ordres disponibles
            randomPointsOrder = arraysOfPointsOrder[Math.floor(Math.random() * arraysOfPointsOrder.length)];
            localStorage.setItem("pointsArrayOrder", JSON.stringify(randomPointsOrder));
          }

          commit("setPointsArray", randomPointsOrder);

          // 7. QUESTIONS
          const langDataQ = getters.lang === "he" ? this.gameData.he : this.gameData.ar;
          const questions = (langDataQ && langDataQ.questions) ? langDataQ.questions : {};

          if (this.gameData.questionsOrder === "sorted") {
            const questionArrayWihoutEmpty = Object.values(questions).filter(
              (q) => q !== null,
            );
            commit("setQuestionsArray", questionArrayWihoutEmpty);
            localStorage.setItem(
              "questionsArray",
              JSON.stringify(questionArrayWihoutEmpty),
            );
            commit("setLoading", false);
          } else if (Object.keys(questions).length > 0) {
            dispatch("checkQuestionListToBeSent", {
              questions: questions,
              randomPointsOrder: randomPointsOrder,
            });
          } else {
            commit("setLoading", false);
          }

          console.log("✅ fetchGameData : Données chargées et mises en cache.");
          return fullData;
        });
    },
    // fetchGameData({ commit, dispatch, getters }, payload) {
    //   commit("setLoading", true);
    //   firebase
    //     .database()
    //     .ref(payload.navigationName)
    //     .once("value")
    //     .then((data) => {
    //       this.gameData = data.val();
    //       // console.log("this.gameData = data.val()", this.gameData);
    //       // **************************FETCH GAME PARAMETERS
    //       var gameParameters = {
    //         // anniversary: this.gameData.anniversary,
    //         infoPage: this.gameData.infoPage,
    //         navigationName: this.gameData.navigationName,
    //         randomQuestions: this.gameData.randomQuestions,
    //         lastPoint: this.gameData.lastPoint,
    //         carousel: this.gameData.carousel,
    //         withVideo: this.gameData.withVideo,
    //         questionsOrder: this.gameData.questionsOrder,
    //         imagesList: this.gameData.imagesList,
    //       };
    //       commit("setGameParameters", gameParameters);
    //       console.log("gameParameters", gameParameters);
    //       // **************************FETCH POINTS
    //       //*********************************************************************************************************** */
    //       // this.points = data.val().he.points;
    //       if (getters.lang == "he") {
    //         // console.log("[index] reloading language HE");
    //         this.points = data.val().he.points;
    //       } else {
    //         // console.log("[index] reloading language AR");
    //         this.points = data.val().ar.points;
    //       }
    //       //*********************************************************************************************************** */
    //       // console.log("[fetchPoints] this.points", this.points);
    //       // CREATE TWO ARRAY OF POINNT INFORMATION AND AUDIO URL TO NOT BE DEPENDING ON THE POINT NUMBER
    //       var arrayOfAudioUrl = [];
    //       var arrayOfPointInfo = [];
    //       var arrayOfImagesBase64 = [];
    //       this.points.forEach(function (point) {
    //         arrayOfAudioUrl.push(point.audioUrl);
    //         arrayOfPointInfo.push(point.pointInformation);
    //         if (gameParameters.carousel || gameParameters.imagesList) {
    //           arrayOfImagesBase64.push(point.imageBase64);
    //         }
    //       });

    //       commit("setArrayOfAudioUrl", arrayOfAudioUrl);
    //       localStorage.setItem(
    //         "arrayOfAudioUrl",
    //         JSON.stringify(arrayOfAudioUrl)
    //       );
    //       // console.log("arrayOfPointInfo", arrayOfPointInfo);

    //       commit("setArrayOfPointInfo", arrayOfPointInfo);
    //       localStorage.setItem(
    //         "arrayOfPointInfo",
    //         JSON.stringify(arrayOfPointInfo)
    //       );
    //       commit("setArrayOfImagesBase64", arrayOfImagesBase64);
    //       // console.log("arrayOfAudioUrl", arrayOfAudioUrl);
    //       localStorage.setItem(
    //         "arrayOfImagesBase64",
    //         JSON.stringify(arrayOfImagesBase64)
    //       );

    //       commit("setPoints", this.points);
    //       // **************************FETCH MAP PARAMERTERS
    //       this.mapParameters = data.val().mapParameters;
    //       // console.log("[fetchPoints] this.mapParameters", this.mapParameters)
    //       commit("setMapParameters", this.mapParameters);
    //       // **************************FETCH MARKERS
    //       this.markers = data.val().markers;
    //       commit("setMarkers", this.markers);
    //       // **************************FETCH WAYPOINTS
    //       if (data.val().wayPoints) {
    //         // this.wayPoints = data.val().wayPoints;
    //         this.wayPoints = data
    //           .val()
    //           .wayPoints.filter((wayPoint) => wayPoint !== null);
    //         console.log("[fetchPoints] this.wayPoints", this.wayPoints);

    //         localStorage.setItem("wayPoints", JSON.stringify(this.wayPoints));
    //         commit("setWayPoints", this.wayPoints);
    //       }

    //       // **************************FETCH POINTS ORDER
    //       var arraysOfPointsOrder = Object.values(data.val().pointsOrder);
    //       if (localStorage.getItem("pointsArrayOrder")) {
    //         var randomPointsOrder = JSON.parse(
    //           localStorage.getItem("pointsArrayOrder")
    //         );
    //         // console.log('[setPointsArray] b4 commit locaol storage payload', payload)
    //         commit("setPointsArray", randomPointsOrder);
    //       } else {
    //         var randomPointsOrder =
    //           arraysOfPointsOrder[
    //             Math.floor(Math.random() * arraysOfPointsOrder.length)
    //           ];
    //         commit("setPointsArray", randomPointsOrder);
    //         localStorage.setItem(
    //           "pointsArrayOrder",
    //           JSON.stringify(randomPointsOrder)
    //         );
    //       }
    //       // **************************FETCH QUESTIONS

    //       if (getters.lang == "he") {
    //         var questions = data.val().he.questions;
    //       } else {
    //         var questions = data.val().ar.questions;
    //       }
    //       if (this.gameData.questionsOrder == "sorted") {
    //         ////////// IF "SORTED", THEN NO RANDOM, ONLY PASS THE QUESTIONS AS APPEAR IN THE DATABASE.
    //         var questionArrayWihoutEmptyQuestion = [];
    //         var arrayQuestion = Object.values(questions);
    //         arrayQuestion.forEach((question) => {
    //           if (question != null) {
    //             questionArrayWihoutEmptyQuestion.push(question);
    //           } else {
    //             console.log("this question is empty", question);
    //           }
    //         });
    //         console.log(
    //           "QUESTIONS SORTED+++++++ questionArrayWihoutEmptyQuestion",
    //           questionArrayWihoutEmptyQuestion
    //         );

    //         commit("setQuestionsArray", questionArrayWihoutEmptyQuestion);
    //         if (!localStorage.getItem("questionsArray")) {
    //           localStorage.setItem(
    //             "questionsArray",
    //             JSON.stringify(questionArrayWihoutEmptyQuestion)
    //           );
    //         }
    //         commit("setLoading", false);
    //       } else {
    //         ////////// IF NOT "SORTED", THEN NORMAL CONTINUATION
    //         dispatch("checkQuestionListToBeSent", {
    //           questions: questions,
    //           randomPointsOrder: randomPointsOrder,
    //         });
    //       }

    //       //******************************************************** */
    //     });
    // },
    checkQuestionListToBeSent({ commit, dispatch, getters }, payload) {
      var questionArrayWihoutEmptyQuestion = [];
      var arrayQuestion = Object.values(payload.questions);
      arrayQuestion.forEach((question) => {
        if (question != null) {
          questionArrayWihoutEmptyQuestion.push(question);
        } else {
          console.log("this question is empty", question);
        }
      });
      if (getters.user) {
        if (getters.gameParameters.randomQuestions === false) {
          var questionsArray = [];
          payload.randomPointsOrder.forEach((point) => {
            questionArrayWihoutEmptyQuestion.map((x) => {
              if (x.pointLinked == point) {
                questionsArray.push(x);
              } else {
              }
            });
          });
          // console.log("NOT RANDOM questionsArray", questionsArray);
          commit("setQuestionsSuffled", questionsArray);
          commit("setQuestionsArray", questionsArray);
          try { localStorage.setItem("questionsArray", JSON.stringify(questionsArray)); } catch(e) { console.warn("questionsArray too large", e); }
        } else {
          dispatch("suffleQuestions", questionArrayWihoutEmptyQuestion);
        }
      } else {
        //* doing a loop until there is a getters.user
        dispatch("checkQuestionListToBeSent", { questions: payload.questions, randomPointsOrder: payload.randomPointsOrder });
      }
      commit("setLoading", false);
    },
    storeSentence({ commit, getters }, payload) {
      let numberOfLetter = payload.sentence.length;
      let sentenceByFour = Math.round(numberOfLetter / 4);
      let redSentence = payload.sentence.slice(0, sentenceByFour);
      let royalblueSentence = payload.sentence.slice(
        sentenceByFour,
        sentenceByFour * 2,
      );
      let darkgreenSentence = payload.sentence.slice(
        sentenceByFour * 2,
        sentenceByFour * 3,
      );
      let purpleSentence = payload.sentence.slice(
        sentenceByFour * 3,
        numberOfLetter,
      );
      firebase
        .database()
        .ref(payload.navigationName + "/sentence/redSentence")
        .set(redSentence);
      firebase
        .database()
        .ref(payload.navigationName + "/sentence/royalblueSentence")
        .set(royalblueSentence);
      firebase
        .database()
        .ref(payload.navigationName + "/sentence/darkgreenSentence")
        .set(darkgreenSentence);
      firebase
        .database()
        .ref(payload.navigationName + "/sentence/purpleSentence")
        .set(purpleSentence);
    },

    suffleQuestions({ commit, dispatch }, payload) {
      this.questions = payload;
      commit("setQuestions", this.questions);
      let questionsShuffled = this.questions;
      let currentIndex = questionsShuffled.length,
        temporaryValue,
        randomIndex;
      // While there remain elements to shuffle...
      while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = questionsShuffled[currentIndex];
        questionsShuffled[currentIndex] = questionsShuffled[randomIndex];
        questionsShuffled[randomIndex] = temporaryValue;
      }
      if (questionsShuffled[0]) {
        console.log("RANDOM questionsShuffled", questionsShuffled);

        commit("setQuestionsSuffled", questionsShuffled);
        commit("setQuestionsArray", questionsShuffled);
        try { localStorage.setItem("questionsArray", JSON.stringify(questionsShuffled)); } catch(e) { console.warn("questionsArray too large", e); }
        // commit('setLoading', false)
      } else {
        dispatch("suffleQuestions", payload);
      }
    },

    /////////////////////////////////////LANGUAGES////////////////////////////////

    switchLanguage({ commit }, payload) {
      commit("switchLang", payload);
    },
  },
  getters: {
    lang(state) {
      return state.lang;
    },
    wazeLink(state) {
      return state.wazeLink;
    },
    arrayOfAudioUrl(state) {
      return state.arrayOfAudioUrl;
    },
    arrayOfPointInfo(state) {
      return state.arrayOfPointInfo;
    },
    arrayOfImagesBase64(state) {
      return state.arrayOfImagesBase64;
    },
    mapParameters(state) {
      return state.mapParameters;
    },
    welcomePage(state) {
      return state.welcomePage;
    },
    lettersArray(state) {
      return state.lettersArray;
    },
    gameParameters(state) {
      return state.gameParameters;
    },
    storyItems(state) {
      return state.storyItems;
    },
    allNavGameNames(state) {
      return state.allNavGameNames;
    },
    loading(state) {
      console.log("[getters] loading => state.loading", state.loading);
      return state.loading;
    },
    results(state) {
      return state.results;
    },
    user(state) {
      return state.user;
    },
    points(state) {
      return state.points;
    },
    markers(state) {
      return state.markers;
    },
    questions(state) {
      return state.questions;
    },
    questionsShuffled(state) {
      return state.questionsShuffled;
    },
    questionsArray(state) {
      return state.questionsArray;
    },
    group(state) {
      return state.group;
    },
    pointsArrayOrder(state) {
      return state.pointsArrayOrder;
    },
    questionsList(state) {
      return state.questionsList;
    },
    users(state) {
      return state.users;
    },
    getUser(state) {
      return (userId) => {
        return state.users.find((user) => {
          return user.id === userId;
        });
      };
    },
  },
};
